// src/components/auth/ElectionProtectedRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Loader from '../common/Loader';

const ElectionProtectedRoute = ({ children, requireSuperAdmin = false }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('election_token');
      const userData = localStorage.getItem('election_user');

      if (token && userData) {
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
        } catch (error) {
          console.error('Error parsing election user data:', error);
          setUser(null);
        }
      } else {
        setUser(null);
      }
      
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <Loader size="lg" text="Loading..." />
      </div>
    );
  }

  // Not authenticated - redirect to election login
  if (!user) {
    return <Navigate to="/admin/election-login" state={{ from: location }} replace />;
  }

  // Check if super admin is required
  if (requireSuperAdmin && user.role !== 'SUPER_ADMIN') {
    return <Navigate to="/admin/election-dashboard" replace />;
  }

  return children;
};

export default ElectionProtectedRoute;